import { ICardElementWithChildren } from "backend/model/model";

export type IDisplaySeries = {
  title?: string;
  value?: keyof ICardElementWithChildren;
  unit?: keyof ICardElementWithChildren;
  valuewithoutsymbol?: keyof ICardElementWithChildren;
  prettyvalue?: keyof ICardElementWithChildren;
  colorKey?: keyof ICardElementWithChildren;
  bgColorKey?: keyof ICardElementWithChildren;
  unitConversionFunction?: (unitName: string) => string;
  localeName?: string;
};

export const getPropsFromContent = (
  data: ICardElementWithChildren,
  content: IDisplaySeries
) => {
  const res = {
    title: content.title || "",
    value: Number(data?.[content.value!] || 0),
    unit: data?.[content.unit!] || "",
    valuewithoutsymbol: data?.[content.valuewithoutsymbol!] || "",
    prettyvalue: data?.[content.prettyvalue!] || "-",
    color: `#${data?.[content.colorKey!] || "000000"}`,
    bgColor: `#${data?.[content.bgColorKey!] || "000000"}`,
    locale: content.localeName || "en-GB",
  };
  if (content.unitConversionFunction && typeof res.unit === "string") {
    res.unit = content.unitConversionFunction(res.unit);
  }
  return res;
};
